import CIMSFormItem from 'components/CIMSFormItem'
import { HelpMessage } from 'utils/constants'
import { useDisabledOptions } from 'hooks/useDisabledOptions'
import { useCheckPermission } from 'hooks/useCheckPermission'
import { Permission } from 'shared'
import { ReviewNotesFormItemProps } from './types'
import CIMSTextArea from 'components/CIMSTextArea'
import { useValidateWhitespaceProps } from 'components/CIMSTextArea/hooks/useValidateWhitespaceProps'

const ReviewNotesFormItem: React.FC<ReviewNotesFormItemProps> = ({
  requiredMessage,
}) => {
  const [disabled, { some }] = useDisabledOptions([
    {
      reason: 'missing permission',
      disabled: !useCheckPermission(Permission.ReviewIdentifiedFieldIssue),
    },
  ])
  return (
    <CIMSFormItem
      requiredMessage={requiredMessage}
      name="reviewNotes"
      help={HelpMessage.IdentifiedFieldIssues.IFITracker.ReviewNotes}
      disabled={disabled}
      {...useValidateWhitespaceProps({ label: 'Review Notes' })}
    >
      <CIMSTextArea disabled={some} />
    </CIMSFormItem>
  )
}

export default ReviewNotesFormItem
